module.exports = __webpack_public_path__ + "static/media/back-arrow-black.deba3a6b.svg";